export const isMentoringActionNeeded = (mentoring) => {
  return (
    mentoring.status === 'pending' ||
    (mentoring.status === 'in progress' && !mentoring.sessions.find(({ date, done }) => done || date))
  );
};
